export default "__VITE_ASSET__DR1r68Bj__"